export enum KeyboardCode {
    TAB = 'Tab',
    ENTER = 'Enter',
    NUMPAD_ENTER = 'NumpadEnter',
    ARROW_UP = 'ArrowUp',
    ARROW_UP_IE = 'Up', // IE specific
    ARROW_DOWN = 'ArrowDown',
    ARROW_DOWN_IE = 'Down', // IE specific
    MINUS = '-'
}